/**
 * Cửa ra của màn "Nhật ký sử dụng AI" ở cổng nền tảng — `/api/v1/audit/ai-usage/*` của audit-service (route nền tảng,
 * `PLATFORM_ADMIN`/`AUDITOR`, mã quyền `AUDIT_EVENTS.READ`).
 *
 * Cùng đường con, cùng tên tham số và cùng hình dạng trả về với `nktv-su-dung-ai.repository.ts` của mặt module, nên
 * một bộ component đọc được cả hai. Khác ở ba chỗ: thêm `tenant_id` (tuỳ chọn — bỏ trống là mọi tenant; bắt buộc khi đọc
 * các bước của một chuỗi vì `trace_id` chỉ duy nhất trong một tenant), mỗi dòng mang `tenant_id`, và có `chi_phi_von`
 * khi người xem có `AI_PRICING.READ`.
 */
import type {
  ChuoiVet,
  KetQuaLuong,
  TrangLuotGoi,
  TrangTrace,
  TruyVanLuong,
  TruyVanLuotGoi,
  TruyVanTrace,
  TuyChonLocAi,
} from '../../modules/nhat-ky-truy-vet/chung/nghiep-vu/types-vet';
import type { ThongKeAi, TruyVanThongKeAi } from '../../modules/nhat-ky-truy-vet/chung/nghiep-vu/types-thong-ke';
import { goiApi } from '../api/http';
import { thamSo, type GiaTriQuery } from './nktv';

const GOC = '/api/v1/audit/ai-usage';

function goi<T>(duongDan: string, query: object, tenantId: string | undefined): Promise<T> {
  return goiApi<T>(`${GOC}${duongDan}`, {
    query: thamSo({ ...(query as Record<string, GiaTriQuery>), tenant_id: tenantId }),
  });
}

export const nktvNenTangRepository = {
  trace: (q: TruyVanTrace, tenantId?: string): Promise<TrangTrace> => goi('/traces', q, tenantId),

  chuoi: (traceId: string, tenantId: string): Promise<ChuoiVet> =>
    goi(`/traces/${encodeURIComponent(traceId)}`, {}, tenantId),

  luotGoi: (q: TruyVanLuotGoi, tenantId?: string): Promise<TrangLuotGoi> => goi('/calls', q, tenantId),

  boLoc: (q: { tu: string; den: string }, tenantId?: string): Promise<TuyChonLocAi> => goi('/filters', q, tenantId),

  luong: (q: TruyVanLuong, tenantId?: string): Promise<KetQuaLuong> => goi('/flows', q, tenantId),

  thongKeAi: (q: TruyVanThongKeAi, tenantId?: string): Promise<ThongKeAi> => goi('/stats', q, tenantId),
};
